import * as ActionTypes from "../actions/actionTypes";

const initialState = {
	appConfig: {},
	appName: "",
	errorMessage: "",
};

export default function appConfigReducer(state = initialState, action) {
	switch (action.type) {
		case ActionTypes.LOAD_APP_CONFIG_SUCCESS:
			return { ...state, appConfig: action.appConfig, appName: action.appName };
		case ActionTypes.LOAD_APP_CONFIG_FAILURE:
		case ActionTypes.SAVE_APP_CONFIG_FAILURE:
			return { ...state, errorMessage: action.errorMessage };
		case ActionTypes.SAVE_APP_CONFIG_SUCCESS:
			return { ...state, appConfig: action.appConfig };
		case ActionTypes.CLEAR_APP_CONFIG:
			return { ...initialState };
		default:
			return state;
	}
}
